module.exports = __webpack_public_path__ + "media/images/default-organization-d9cefa6b.png";